import { EventType } from './Types';

export const onClick = (el: HTMLElement, fn: (this: HTMLElement, ev: MouseEvent) => void) =>
  el.addEventListener(EventType.Click, fn);

export const onKeydown = (fn: (arg0: KeyboardEvent) => void) => {
  document.addEventListener('keydown', fn);
};
